export default class FilterAccountsRequest {
    pageNumber: number = 1;
    pageSize: number = 10;
    name: string;
    paymentAccountIdentifier: string;
    customerName: string;
    productId: string;
    productIssueId: string;
}